<template>
  <label
    class="sf-form-check sf-checkbox"
    data-testid="sf-checkbox"
    :class="containerClass"
  >
    <slot name="left-side"> </slot>
    <input
      v-bind="$attrs"
      class="sf-checkbox__input"
      :checked="modelValue"
      type="checkbox"
      :disabled="disabled"
      @click="handleChange"
    />
    <span
      class="sf-checkbox__box"
      :class="{ 'sf-checkbox__box--indeterminate': indeterminate }"
      aria-hidden="true"
    >
      <!-- The glyph paths are drawn in the box's 16x16 content coordinates
           (viewBox "3 2 16 16"), so each svg fills the box and carries its own
           position; nothing here centers them. -->
      <svg
        v-if="indeterminate"
        class="sf-checkbox__dash"
        data-testid="sf-checkbox-dash"
        viewBox="3 2 16 16"
        fill="currentColor"
      >
        <rect x="6.625" y="9.0625" width="8.75" height="1.875" rx="0.625" />
      </svg>
      <svg
        v-else
        class="sf-checkbox__check"
        data-testid="sf-checkbox-check"
        viewBox="3 2 16 16"
        fill="currentColor"
      >
        <path
          d="M9.37891 13.8438L6.13672 10.6016C5.94141 10.4062 5.94141 10.0742 6.13672 9.87891L6.83984 9.17578C7.03516 8.98047 7.34766 8.98047 7.54297 9.17578L9.75 11.3633L14.4375 6.67578C14.6328 6.48047 14.9453 6.48047 15.1406 6.67578L15.8438 7.37891C16.0391 7.57422 16.0391 7.90625 15.8438 8.10156L10.1016 13.8438C9.90625 14.0391 9.57422 14.0391 9.37891 13.8438Z"
        />
      </svg>
    </span>
    <span v-if="label" class="sf-checkbox__label">{{ label }}</span>
    <slot name="right-side"> </slot>
  </label>
</template>
<script setup lang="ts">
import { computed } from 'vue'

defineOptions({
  name: 'SfCheckbox',
  inheritAttrs: false,
})

interface Props {
  disabled?: boolean
  display?: 'inline' | 'block'
  label?: string
  modelValue?: boolean
  indeterminate?: boolean
}

const props = withDefaults(defineProps<Props>(), {
  display: 'inline',
  label: '',
})

const emit =
  defineEmits<{
    'update:modelValue': [boolean]
  }>()

const containerClass = computed(() => ({
  'sf-inline-block': props.display === 'block',
  'sf-level': props.display === 'inline',
}))

function handleChange(event: Event) {
  if (props.disabled) return
  if (props.indeterminate) {
    event.preventDefault()
  }
  emit('update:modelValue', !props.modelValue)
}
</script>
